module.exports = __webpack_public_path__ + "static/media/vector-dark.723a2c19.svg";